import React, { useEffect, useState, useContext } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import { Route, Routes } from "react-router-dom";
import Settings from "./Settings";
import Homepage from "./Homepage";
import Campaign from "./Campaign";
import ClientCampaign from "./ClientCampaign";
import Report from "./Report";
import instance from "../axios/global";
import { AuthContext } from "../auth/auth";

const Accueil = () => {
  const [allProjects, setAllProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const { authState, setAuthState } = useContext(AuthContext);

  // Récupérer l'état d'authentification de l'utilisateur
  useEffect(() => {
    instance
      .get("/user/auth", {
        headers: {
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((res) => {
        if (res.data.error) {
          setAuthState({ ...authState, status: false });
        } else {
          localStorage.setItem("user", JSON.stringify(res.data));
          setAuthState({
            name: res.data.firstName,
            email: res.data.email,
            id: res.data.id,
            status: true,
          });
        }
      });
  }, []);

  // Charger la liste des projets et restaurer le projet sélectionné
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await instance.get(`/client/all/${authState?.id}`);
        if (res?.data.length > 0) {
          setAllProjects(res.data);

          // Restaurer le projet sélectionné depuis le localStorage
          const savedProjectId = localStorage.getItem("selectedProject");
          if (
            savedProjectId &&
            res.data.some((project) => project.id.toString() === savedProjectId)
          ) {
            setSelectedProject(savedProjectId);
          } else {
            setSelectedProject(res?.data[0]?.id.toString());
          }
        } else {
          setAllProjects([]);
        }
      } catch (error) {
        console.log("Erreur lors du chargement des projets : ", error);
      }
    };

    if (authState?.id) {
      fetchProjects();
    }
  }, [authState?.id]);

  // Sauvegarder le projet sélectionné dans le localStorage
  const handleProjectChange = (newProject) => {
    setSelectedProject(newProject);
    localStorage.setItem("selectedProject", newProject); // Sauvegarde de l'ID sélectionné
  };

  const updateProjectsList = async () => {
    try {
      const res = await instance.get(`/client/all/${authState?.id}`);
      setAllProjects(res?.data);
    } catch (error) {
      console.log("Erreur lors du chargement des projets : ", error);
    }
  };

  return (
    <div className="accueil">
      <Sidebar selectedProject={selectedProject} />
      <div className="content">
        <Navbar
          selectedProject={selectedProject}
          onProjectChange={handleProjectChange}
          allProjects={allProjects}
          updateProjectsList={updateProjectsList}
        />
        <section className="section-switch-nav">
          <div className="div-switch">
            <Routes>
              <Route path="/homepage" element={<Homepage />} />
              <Route path="/campagne/:id" element={<Campaign />} />
              <Route path="/campagnes/:id" element={<ClientCampaign />} />
              <Route path="/parametres/:id" element={<Settings />} />
              <Route path="/client/:id/:name" element={<ClientCampaign />} />
              <Route path="/rapport/:id" element={<Report />} />
            </Routes>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Accueil;
